import { render } from "./NoticeView.vue?vue&type=template&id=6b541c5a&scoped=true"
import script from "./NoticeView.vue?vue&type=script&lang=js"
export * from "./NoticeView.vue?vue&type=script&lang=js"

import "./NoticeView.vue?vue&type=style&index=0&id=6b541c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b541c5a"]])

export default __exports__